// extracted by mini-css-extract-plugin
module.exports = {"itemIcon":"GameIntro_itemIcon__09VZ3"};